import { UrlProviderService } from './local/url-provider.service';
import { HttpinterceptorService } from './httpinterceptor';
import * as i0 from "@angular/core";
import * as i1 from "./local/url-provider.service";
import * as i2 from "./httpinterceptor";
export class CustomerService {
    constructor(urlProvider, http) {
        this.urlProvider = urlProvider;
        this.http = http;
    }
    checkCustomerByIdentifier(identifier) {
        var url = this.urlProvider.checkCustomerByIdentifier(identifier);
        return this.http.getRequest(url, true).toPromise().then((res) => res);
    }
    checkCustomerByNviService(requestPayload) {
        var url = this.urlProvider.getCheckCustomerByNviServiceURL();
        return this.http.postRequest(url, requestPayload, true).toPromise().then((res) => res);
    }
}
CustomerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomerService_Factory() { return new CustomerService(i0.ɵɵinject(i1.UrlProviderService), i0.ɵɵinject(i2.HttpinterceptorService)); }, token: CustomerService, providedIn: "root" });
